import { bindings } from '@polleverywhere/slideware-bindings'
import store from '@polleverywhere/redux'
import { slice as appSlice } from '../slices/app'

export default async function openWindow (url, { name = '_system', features = ['noopener'] } = {}) {
  if (store.getState()[appSlice.name].mode === 'integration') {
    await bindings.openBrowser({ url })
  } if (window.Office?.UI?.openBrowserWindow) { // Not sure if we can call this in browser
    window.Office.UI.openBrowserWindow(url)
  } else {
    window.open(url, name, features.join(','))
  }
}
